// extracted by mini-css-extract-plugin
export default {"dots":"Dots_dots__fHRrg","item":"Dots_item__A9GJW","active":"Dots_active__uTrh8","top":"Dots_top__MFWom","contacts":"Dots_contacts__-lyyX"};